const STATE_BY_VARIANT = Object.freeze({ success: 'done', failure: 'failed' });

/**
 * What a workflow run did, step by step, in the definition's order: each step's name and whether it worked,
 * failed or never ran. The result is the run's own summary, or the failure headline when it failed.
 */
const buildWorkflowRunStepList = ({ run, steps = [], nameByStepId = {}, statusByStepId = {}, failure = null }) => {
  const stepList = steps.map((step) => {
    const status = statusByStepId[step.id];

    return {
      id: step.id,
      label: nameByStepId[step.id] || step.name || 'Step',
      state: status ? STATE_BY_VARIANT[status.statusVariant] || 'queued' : 'queued',
      note: status ? null : 'Did not run',
      error: status?.statusVariant === 'failure' && failure?.targetStepName === (nameByStepId[step.id] || step.name) ? failure.headline : null
    };
  });

  return { steps: stepList, result: run?.summary || failure?.headline || null };
};

export default buildWorkflowRunStepList;
